import {
  AccessContext,
  EnumField,
  LoggerFactory,
  Required
} from "lego-gui-lib";
import { t } from "../../core/i18n/i18n";
import { serviceProfileAllows } from "../serviceProfile/validator";

const log = LoggerFactory.create("RoutingTypeEnum");

export enum RoutingType {
  NO_TRANSLATION,
  TRANSLATION,
  ANNOUNCEMENT,
  ROUTING_TREE
}

export const RoutingTypeValues = [
  {
    label: t("hns:san:routingTypeEnum:noTranslation"),
    value: RoutingType.NO_TRANSLATION,
    serviceProfileFlag: "routingTypeNoTranslation"
  },
  {
    label: t("hns:san:routingTypeEnum:translation"),
    value: RoutingType.TRANSLATION,
    serviceProfileFlag: "routingTypeTranslation"
  },
  {
    label: t("hns:san:routingTypeEnum:announcement"),
    value: RoutingType.ANNOUNCEMENT,
    serviceProfileFlag: "routingTypeAnn"
  },
  {
    label: t("hns:san:routingTypeEnum:routingTree"),
    value: RoutingType.ROUTING_TREE,
    serviceProfileFlag: "routingTypeTree"
  }
];

export const RoutingTypeEnum = (ctx: AccessContext) => {
  log.debug("Enum ctx", ctx);

  return EnumField(
    RoutingTypeValues.filter(rt =>
      serviceProfileAllows(ctx, rt.serviceProfileFlag)
    ),
    Required
  );
};
